"use client";

import React, { useEffect, useState } from "react";
import { ArrowRight, Play } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function IndulgeInInnovation() {
  const [mouseOffset, setMouseOffset] = useState({
    x: 0,
    y: 0
  });
  const [isVideoPlaying, setIsVideoPlaying] = useState(true);
  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      const x = (e.clientX / window.innerWidth - 0.5) * 2;
      const y = (e.clientY / window.innerHeight - 0.5) * 2;
      setMouseOffset({
        x,
        y
      });
    };
    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);
  return <section data-section-id="228836" id="engineering-the-future-of-precision-medicine" className="relative min-h-[90vh] flex items-center bg-background dark overflow-hidden py-20 lg:py-0">
      {}
      <svg className="hidden" aria-hidden="true">
        <defs>
          <filter id="melting-text-filter">
            <feGaussianBlur in="SourceGraphic" stdDeviation="1.2" result="blur" />
            <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -7" result="goo" />
            <feComposite in="SourceGraphic" in2="goo" operator="atop" />
          </filter>
        </defs>
      </svg>

      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute -top-[20%] -left-[10%] w-[50%] h-[50%] rounded-full bg-primary/10 blur-[120px]" />
        <div className="absolute top-[60%] -right-[10%] w-[40%] h-[60%] rounded-full bg-secondary/15 blur-[100px]" />
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10 max-w-7xl">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center">
          
          {}
          <div className="flex flex-col items-start space-y-8 max-w-2xl">
            <div className="space-y-4">
              <h1 className="font-default text-6xl sm:text-7xl lg:text-8xl font-bold tracking-tighter text-foreground leading-[1.1] pb-2" style={{
              filter: "url(#melting-text-filter)"
            }}>
                Engineering <br />
                <span className="text-primary italic pr-4">Precision Medicine</span>
              </h1>
              <p className="font-default text-lg sm:text-xl text-muted-foreground leading-relaxed max-w-lg">
                Eirion Technology integrates fractional CTO leadership, the Eir SaaS platform for clinical decision support, and advanced genetic diagnostics to redefine the landscape of precision healthcare.
              </p>
            </div>

            <div className="flex flex-wrap items-center gap-4 pt-4">
              <Button asChild size="lg" className="rounded-md px-8 py-6 text-lg shadow-xl shadow-primary/40 transition-transform hover:scale-105 bg-primary text-primary-foreground">
                <Link to="#">
                  Explore the Platform
                  <ArrowRight className="ml-2 size-5" />
                </Link>
              </Button>
              <Button variant="ghost" size="lg" className="rounded-md px-6 py-6 text-lg font-medium border border-secondary/30 hover:bg-secondary/20 text-foreground transition-all hover:shadow-[0_0_20px_rgba(168,85,247,0.2)]">
                <Link to="#">
                  Consult our Lab
                </Link>
              </Button>
            </div>
            
            {}
            <div className="flex items-center gap-6 pt-8 border-t border-border/20 w-full max-w-md">
              <div className="flex flex-col">
                <span className="font-default text-2xl font-bold text-foreground">Strategic</span>
                <span className="font-default text-sm text-muted-foreground">Fractional CTO Services</span>
              </div>
              <div className="w-px h-10 bg-border/20"></div>
              <div className="flex flex-col">
                <span className="font-default text-2xl font-bold text-foreground">Advanced</span>
                <span className="font-default text-sm text-muted-foreground">Genetics & Lab Diagnostics</span>
              </div>
            </div>
          </div>

          {}
          <div className="relative w-full aspect-square max-w-[600px] mx-auto lg:ml-auto mt-10 lg:mt-0">
            
            {}
            <div className="absolute -top-10 -right-10 z-20 w-32 h-32 transition-transform duration-200 ease-out drop-shadow-2xl hidden md:block" style={{
            transform: `translate(${mouseOffset.x * 30}px, ${mouseOffset.y * 30}px) rotate(${mouseOffset.x * 10}deg)`
          }}>
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1643670/img/honeycomb_3d_element.png" alt="Digital Data Structure" className="w-full h-full object-contain opacity-90" />
            </div>

            {}
            <div className="absolute -bottom-16 -left-12 z-20 w-40 h-40 transition-transform duration-200 ease-out drop-shadow-2xl hidden md:block" style={{
            transform: `translate(${mouseOffset.x * -40}px, ${mouseOffset.y * -20}px) rotate(${mouseOffset.y * -15}deg)`
          }}>
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1643670/img/lavender_sprig_3d.png" alt="Biological Insight" className="w-full h-full object-contain opacity-90" />
            </div>

            {}
            <div className="relative w-full h-full p-4">
              {}
              <div className="absolute inset-0 bg-secondary/20 transition-transform duration-700 ease-in-out border border-white/5" style={{
              borderRadius: "60% 40% 30% 70% / 60% 30% 70% 40%",
              transform: `rotate(${mouseOffset.x * 5}deg) scale(1.05)`
            }} />
              
              {}
              <div className="relative w-full h-full overflow-hidden shadow-2xl shadow-primary/20 bg-card border border-white/10" style={{
              borderRadius: "40% 60% 70% 30% / 40% 50% 60% 50%"
            }}>
                <video autoPlay loop muted playsInline className="absolute inset-0 w-full h-full object-cover scale-105 opacity-80" poster="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1643670/img/silky_chocolate_scoop_poster.png">
                  <source src="https://cdn.pixabay.com/video/2023/10/22/186008-876930030_large.mp4" type="video/mp4" />
                  {}
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1643670/img/silky_chocolate_scoop_poster.png" alt="Precision medical visualization" className="w-full h-full object-cover" />
                </video>
                
                {}
                <div className="absolute inset-0 bg-gradient-to-tr from-background/40 via-transparent to-transparent pointer-events-none" />
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </section>;
}